"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filtersToQueryString = exports.DATE_FILTER_OPERATION = exports.NUMBER_FILTER_OPERATION = exports.NULL_FILTER_OPERATION = exports.STRING_FILTER_OPERATION = void 0;
const FILTER_OPERATION = {
    BETWEEN: 'between',
    CONTAINS: 'contains',
    EQUALS: 'equals',
    GREATER: 'greater',
    IN: 'in',
    IS_NULL: 'is-null',
    LESS: 'less',
};
// string
exports.STRING_FILTER_OPERATION = {
    CONTAINS: FILTER_OPERATION.CONTAINS,
    EQUALS: FILTER_OPERATION.EQUALS,
    IN: FILTER_OPERATION.IN,
};
// null
exports.NULL_FILTER_OPERATION = {
    IS_NULL: FILTER_OPERATION.IS_NULL,
};
// number
exports.NUMBER_FILTER_OPERATION = {
    EQUALS: FILTER_OPERATION.EQUALS,
    BETWEEN: FILTER_OPERATION.BETWEEN,
    LESS: FILTER_OPERATION.LESS,
    GREATER: FILTER_OPERATION.GREATER,
    IN: FILTER_OPERATION.IN,
};
// date
exports.DATE_FILTER_OPERATION = {
    EQUALS: FILTER_OPERATION.EQUALS,
    BETWEEN: FILTER_OPERATION.BETWEEN,
    LESS: FILTER_OPERATION.LESS,
    GREATER: FILTER_OPERATION.GREATER,
    IN: FILTER_OPERATION.IN,
};
/**
 * @description
 * Return the string value of an intended filter value
 *
 * @param value
 */
function stringifyFilterValue(value) {
    // Truncate the milliseconds off the date
    if (value instanceof Date)
        return encodeURIComponent(`${value.toISOString().slice(0, -5)}Z`);
    return encodeURIComponent(value);
}
/**
 * @description
 * Convert a field filter to a query string
 *
 * @param currentIndex
 * @param field
 * @param filter
 *
 * @returns object and nextIndex
 */
function filterToQueryString(currentIndex, field, filter) {
    if (!(filter instanceof Array)) {
        switch (filter.operation) {
            case FILTER_OPERATION.IN: return [Object.assign({ [`filter[${currentIndex}][field]`]: field, [`filter[${currentIndex}][operation]`]: filter.operation }, (Object.fromEntries(filter.value.map((value, index) => [
                    `filter[${currentIndex}][value][${index}]`,
                    stringifyFilterValue(value),
                ])))), currentIndex + 1];
            case FILTER_OPERATION.IS_NULL: return [{
                    [`filter[${currentIndex}][field]`]: field,
                    [`filter[${currentIndex}][operation]`]: filter.operation,
                }, currentIndex + 1];
            case FILTER_OPERATION.BETWEEN: return [Object.assign({ [`filter[${currentIndex}][field]`]: field, [`filter[${currentIndex}][operation]`]: filter.operation, [`filter[${currentIndex}][value][0]`]: stringifyFilterValue(filter.value[0]), [`filter[${currentIndex}][value][1]`]: stringifyFilterValue(filter.value[1]) }, (filter.inclusive !== undefined ? { [`filter[${currentIndex}][inclusive]`]: filter.inclusive.toString() } : {})), currentIndex + 1];
            case FILTER_OPERATION.CONTAINS:
            case FILTER_OPERATION.EQUALS: return [{
                    [`filter[${currentIndex}][field]`]: field,
                    [`filter[${currentIndex}][operation]`]: filter.operation,
                    [`filter[${currentIndex}][value]`]: stringifyFilterValue(filter.value),
                }, currentIndex + 1];
            case FILTER_OPERATION.GREATER:
            case FILTER_OPERATION.LESS: return [Object.assign({ [`filter[${currentIndex}][field]`]: field, [`filter[${currentIndex}][operation]`]: filter.operation, [`filter[${currentIndex}][value]`]: stringifyFilterValue(filter.value) }, (filter.inclusive !== undefined ? { [`filter[${currentIndex}][inclusive]`]: filter.inclusive.toString() } : {})), currentIndex + 1];
            default: throw new TypeError(`Unhandled filter operation: "${filter.operation}"`);
        }
    }
    // TODO: use array methods instead of for loop
    let queryParamsObject = {};
    let runningIndex = currentIndex;
    for (let i = 0; i < filter.length; i++) {
        const [moreQueryParams, resultIndex] = filterToQueryString(runningIndex, field, filter[i]);
        runningIndex = resultIndex + 1;
        queryParamsObject = Object.assign(Object.assign({}, queryParamsObject), moreQueryParams);
    }
    return [queryParamsObject, runningIndex];
}
/**
 * @description
 * Convert a set of filters into a query string
 *
 * @param allFilters
 */
function filtersToQueryString(allFilters) {
    let runningIndex = 0;
    let queryParamsObject = {};
    // go over all fields
    for (const [field, fieldFilters] of Object.entries(allFilters)) {
        fieldFilters.forEach(fieldFilter => {
            const [moreQueryParams, nextIndex] = filterToQueryString(runningIndex, field, fieldFilter);
            runningIndex = nextIndex;
            queryParamsObject = Object.assign(Object.assign({}, queryParamsObject), moreQueryParams);
        });
    }
    return queryParamsObject;
}
exports.filtersToQueryString = filtersToQueryString;
